import IntlMessageFormat from 'intl-messageformat'
import * as LodashFP from 'lodash/fp'

import translations from '../app/translations.json'
import { IStringAnyMap } from '../types/map'
import DI from '../app/di'

// export type Locale = 'en' | 'de'
export type Locale = string
export type MsgId = keyof typeof translations
export type TranslateContext = IStringAnyMap

export function translate(
  locale: Locale,
  msgId: MsgId,
  fallback: string,
  context: TranslateContext,
): string {
  const msg: string = LodashFP.getOr(fallback, [msgId, locale], translations)
  if (msg === msgId) {
    return msgId
  }

  const message = new IntlMessageFormat(msg, locale)
  return message.format(context).trim()
}

export function translateWithUserLocale(
  msgId: MsgId,
  context: TranslateContext = {},
): string {
  const locale = DI.get('locale')

  return translate(locale, msgId, msgId, context)
}

export function __tryToTranslateWithUserLocale__do_not_use_unless_absolutely_needed(
  maybeMsgId: string,
  fallback: string,
  context: TranslateContext = {},
) {
  const locale = DI.get('locale')

  return translate(locale, maybeMsgId as MsgId, fallback, context)
}
